export default __webpack_public_path__ + "static/media/check_icon.81a93758.jpeg";